firebird.controller('uniteDuplicateLoginCtrl', [
    '$window',
    'meetingService',
    function ($window, meetingService) {
        var self = this;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.refresh = refresh;

        function refresh() {
            $window.location.reload();
        }
    }
]);
